<template>
  <div class="my_order">
    <van-nav-bar
      title="我的订单"
      left-text=""
      right-text=""
      left-arrow
      @click-left="backToMy"
    />
    <van-tabs v-model="active" color="#f5222d" :swipe-threshold="6">
      <order-tab title="全部" />
      <order-tab title="待支付" :status="1" />
      <order-tab title="已支付" :status="2" />
      <order-tab title="已退款" :status="3" />
      <order-tab title="已取消" :status="5" />
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, NavBar } from 'vant'
import OrderTab from './components/OrderTab'

export default {
  name: 'MyOrder',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [NavBar.name]: NavBar,
    OrderTab
  },
  data () {
    return {
      active: 0
    }
  },
  methods: {
    backToMy() {
      this.$router.push('/my')
    }
  }
}
</script>

<style scoped lang="scss">
.my_order{
  background-color: #f8f8f8;
}
</style>
